exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3LQw {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin: 16px 0;\n  max-width: 300px;\n  margin-right: 16px; }\n\ninput {\n  padding: 8px 4px;\n  margin: 8px 0;\n  width: 300px;\n  text-indent: 16px;\n  height: 38px;\n  border: 1px solid #707070;\n  border-radius: 2px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n\n.AzwA {\n  margin-bottom: 8px;\n  font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"container": "_3LQw",
	"label": "AzwA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import /"variables/";","includePaths":["/app/src/styles"]}!./src/components/FieldWrapper/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import \"variables\";","includePaths":["/app/src/styles"]}!./src/components/FieldWrapper/styles.scss
// module chunks = 0